import {
  getmaxAnswerableQuestions,
  getAllAnswersBySection
} from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';

const getCount = (data) => {
  return Object.keys(data).reduce((sum, value) => sum + data[value], 0);
};

const useTotalSummary = () => {
  const answersBySection = useSelectorWithShallowEqual(getAllAnswersBySection);
  const maxAnswerableQuestionBySection = useSelectorWithShallowEqual(
    getmaxAnswerableQuestions
  );

  const answeredQuestionsCountInEachSection = {};

  Object.keys(answersBySection).forEach((key) => {
    answeredQuestionsCountInEachSection[key] = Object.keys(
      answersBySection[key]
    ).length;
  });

  const totalAttemptedCount = getCount(answeredQuestionsCountInEachSection);
  const maxQuestionsToAnswer = getCount(maxAnswerableQuestionBySection);

  return {
    attemptedQuestionCount: totalAttemptedCount,
    skippedQuestionCount: maxQuestionsToAnswer - totalAttemptedCount
  };
};

export default useTotalSummary;
